// @owners { team: patients-team }
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { type Location, useLocation } from 'react-router-dom';

type NavigationContextValue = {
  current: Location | undefined;
  previous: string | undefined;
};
const NavigationContext = createContext<NavigationContextValue>({ current: undefined, previous: undefined });

export const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const previousPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    if (location.pathname !== previousPathRef.current) {
      window.scrollTo(0, 0);
      previousPathRef.current = location.pathname;
    }
  });

  return (
    <NavigationContext.Provider value={{ current: location, previous: previousPathRef.current }}>
      {children}
    </NavigationContext.Provider>
  );
};

export function useNavigationContext() {
  return useContext(NavigationContext);
}
